// Système de gestion des données partagées entre admin et site principal
class SharedDataManager {
  constructor() {
    this.STORAGE_KEY = 'sharedCasinosData';
    this.LAST_UPDATED_KEY = 'casinosLastUpdated';
  }

  // Sauvegarder les données dans le localStorage
  saveCasinos(casinos) {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(casinos));
      localStorage.setItem(this.LAST_UPDATED_KEY, Date.now().toString());
      console.log('Casinos data saved to localStorage');
      
      // Déclencher un événement pour notifier les autres onglets/pages
      window.dispatchEvent(new CustomEvent('casinosUpdated', { 
        detail: { casinos, timestamp: Date.now() } 
      }));
      
      return true;
    } catch (error) {
      console.error('Error saving casinos data:', error);
      return false;
    }
  }

  // Récupérer les données du localStorage
  getCasinos() {
    try {
      const data = localStorage.getItem(this.STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Error loading casinos data:', error);
      return null;
    }
  }

  // Vérifier si les données ont été mises à jour récemment
  getLastUpdated() {
    const timestamp = localStorage.getItem(this.LAST_UPDATED_KEY);
    return timestamp ? parseInt(timestamp) : 0;
  }

  // Vérifier si les données locales sont plus récentes que les données par défaut
  hasUpdatedData() {
    return this.getCasinos() !== null && this.getLastUpdated() > 0;
  }

  // Effacer les données
  clearData() {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
      localStorage.removeItem(this.LAST_UPDATED_KEY);
      console.log('Casinos data cleared from localStorage');
      
      // Déclencher un événement
      window.dispatchEvent(new CustomEvent('casinosUpdated', { 
        detail: { casinos: null, timestamp: Date.now() } 
      }));
      
      return true;
    } catch (error) {
      console.error('Error clearing casinos data:', error);
      return false;
    }
  }

  // Écouter les changements de données
  onDataChanged(callback) {
    const handler = (event) => {
      callback(event.detail);
    };
    
    window.addEventListener('casinosUpdated', handler);
    
    // Retourner une fonction de nettoyage
    return () => {
      window.removeEventListener('casinosUpdated', handler);
    };
  }

  // Synchroniser avec les changements d'autres onglets
  onStorageChanged(callback) {
    const handler = (event) => {
      if (event.key === this.STORAGE_KEY || event.key === this.LAST_UPDATED_KEY) {
        callback(this.getCasinos());
      }
    };
    
    window.addEventListener('storage', handler);
    
    return () => {
      window.removeEventListener('storage', handler);
    };
  }
}

export default new SharedDataManager();